import React from 'react';
import BlockContainer from './BlockContainer';
import Button from '../Button';

export default function ContentBlock({
  title,
  description,
  link,
  bgColor,
  textColor,
  padding,
}) {
  return (
    <BlockContainer bgColor={bgColor} textColor={textColor} padding={padding}>
      <div className="max-w-3xl mx-auto">
        <h2 className="font-sonoma text-2xl font-normal mb-3">{title}</h2>
        {description ? (
          <div className="font-sonoma text-2xl font-light mb-8 lg:px-10">
            {description}
          </div>
        ) : null}
        {link?.link_text && link?.link_url ? (
          <Button yellow solid lg to={link.link_url}>
            {link.link_text}
          </Button>
        ) : null}
      </div>
    </BlockContainer>
  );
}
